import inventoryModule from "./inventory";

export const inventoryModules = {
  inventory: inventoryModule,
};
